angular.module('unergie.main')
.controller('feesCheckModalCtrl', ($scope, $uibModalInstance, ApiBilling, AlertManager, ErrorCatcher) => {
    $scope.close = $uibModalInstance.dismiss

    $scope.id_contract = ''

    $scope.searchFees = function () {
        $scope.searchingFees = true
        const search = {}
        if ($scope.id_contract) {
            search.id_contract = $scope.id_contract
        }
        return ApiBilling.checkFees(search).$promise.then((data) => {
            $scope.contractsElec = data
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.searchingFees = false
        })
    }

    $scope.computeFee = (fee) => {
        return (fee.amount_tax_exc * (1 + (fee.vat_rate / 100)))
    }

    $scope.computeInvoice = (contractElec) => {
        return _.sumBy(_.filter(contractElec.fees, 'selected'), $scope.computeFee)
    }

    $scope.toggleContract = (contractElec) => {
        contractElec.selected = !contractElec.selected
        _.each(contractElec.fees, (f) => {
            f.selected = contractElec.selected
        })
    }

    $scope.toggleFee = (fee, contractElec) => {
        fee.selected = !fee.selected
        if (fee.selected) {
            contractElec.selected = true
        }
        if (_.every(contractElec.fees, (f) => !f.selected)) {
            contractElec.selected = false
        }
    }

    $scope.canLaunch = () => {
        return _.some($scope.contractsElec, 'selected')
    }

    $scope.selectAll = (value = true) => {
        _.each($scope.contractsElec, (c) => {
            c.selected = value
            _.each(c.fees, (f) => {
                f.selected = value
            })
        })
    }

    $scope.launch = () => {
        $scope.launching = true
        const payload = _.map(_.filter($scope.contractsElec, 'selected'), (c) => _.map(_.filter(c.fees, 'selected'), 'id'))
        return ApiBilling.createMisc(payload).$promise.then((data) => {
            const count = _.countBy(data, (d) => !d.error)
            if (count.false) {
                AlertManager.error(`Le process a rencontré des erreurs, nb ok : ${count.true || 0}, nb error: ${count.false}`, 6000, _.filter(data, (d) => !!d.error))
            } else {
                AlertManager.success(`${count.true} Factures créés en succès`)
            }
            $scope.searchFees()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.launching = false
        })
    }

    $scope.done = $uibModalInstance.close
})
